import React, { useEffect, useState } from 'react';
import type { EditorValue } from '~/components/organism/PluginsEditor/types';
import MarkdownEditorBase from '~/components/molecule/MarkdownEditorBase';
import deserializeMarkdown from '~/components/molecule/MarkdownEditorBase/utils/deserializeMarkdown';
import serializeMarkdown from '~/components/molecule/MarkdownEditorBase/utils/serializeMarkdown';

export type Props = {
  /** Markdown string */
  value: string;

  /** Update the form state */
  onChange: (value: string) => void;
};

const MarkdownEditor: React.FCC<Props> = ({ value = '', onChange }) => {
  const [editorValue, setEditorValue] = useState<EditorValue>(
    deserializeMarkdown(value),
  );

  useEffect(() => {
    // We need to serialize the editor value on each change to be able to
    // display it in the preview
    if (editorValue) onChange(serializeMarkdown(editorValue));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editorValue]);

  return <MarkdownEditorBase value={editorValue} onChange={setEditorValue} />;
};

export default MarkdownEditor;
